import { normalizeOrders } from './normalize-orders';
import { parse } from 'json2csv';

export function pendingOrdersToCsv(pendingOrders) {
  const normalizedData = normalizeOrders(pendingOrders);

  const fields = Object.keys(normalizedData[0]);
  const opts = { fields };

  return parse(normalizedData, opts);
}
